"use strict";
focus.$inject = ["$rootScope", "$timeout"];
Object.defineProperty(exports, "__esModule", { value: true });
exports.focus = exports.focusOn = void 0;
function focusOn() {
    return function (scope, elem, attr) {
        scope.$on('focusOn', function (_e, name) {
            if (name === attr.focusOn) {
                elem[0].focus();
            }
        });
    };
}
exports.focusOn = focusOn;
/* @ngInject */
function focus($rootScope, $timeout) {
    return function (name) {
        $timeout(function () {
            $rootScope.$broadcast('focusOn', name);
        });
    };
}
exports.focus = focus;
